import { get as lodashGet, isNil } from 'lodash';
import { RaRecord } from 'ra-core';

export const formatCents = (cents: number) => {
  if (isNil(cents)) {
    return null;
  }
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const getInheritedValue = (
  inheritedSettings: Record<string, any>,
  key: string,
  parentSettings?: Record<string, any>,
) => {
  const value = lodashGet(inheritedSettings, key);
  if (!isNil(value) && value !== '') {
    return value;
  }

  const parentValue = lodashGet(parentSettings, key);
  if (!isNil(parentValue) && parentValue !== '') {
    return parentValue;
  }

  return null;
};

export const getInherited = (
  inheritedSettings: Record<string, any>,
  key: string,
  parentSettings?: Record<string, any>,
) => {
  const value = getInheritedValue(inheritedSettings, key, parentSettings);
  if (isNil(value)) {
    return '';
  }
  return String(value) || '';
};

export const formatInheritedCents = (
  inheritedSettings: Record<string, any>,
  key: string,
  parentSettings?: Record<string, any>,
) => formatCents(getInheritedValue(inheritedSettings, key, parentSettings));

export const getRateSource = (record: RaRecord, resource: string) => {
  // Location or Agency
  if (
    resource === 'AgencyLocationPositionRateSetting' ||
    resource === 'AgencyLocationRateSetting' ||
    resource === 'LocationPositionRateSetting' ||
    resource === 'LocationRateSetting' ||
    record?.location_id
  ) {
    if (
      resource === 'AgencyLocationPositionRateSetting' ||
      resource === 'AgencyLocationRateSetting' ||
      record?.agency_id
    ) {
      return 'agency_id';
    }
    return 'location_id';
  }

  // Market Location Type
  if (
    resource === 'MarketLocationTypePositionRateSetting' ||
    resource === 'MarketLocationTypeRateSetting' ||
    (record?.market_id && record?.location_type_id)
  ) {
    return 'market_location_type_id';
  }

  // Market
  if (
    resource === 'MarketPositionRateSetting' ||
    resource === 'MarketRateSetting' ||
    record?.market_id
  ) {
    return 'market_id';
  }

  // State Location Type
  if (
    resource === 'StateLocationTypePositionRateSetting' ||
    resource === 'StateLocationTypeRateSetting' ||
    record?.location_type_id
  ) {
    return 'state_location_type_id';
  }

  // State
  if (
    resource === 'StatePositionRateSetting' ||
    resource === 'StateRateSetting' ||
    record?.state_id
  ) {
    return 'state_id';
  }

  throw new Error('No rate representation found');
};
